import { args } from 'nest/common/args';
import { defineCapability } from 'nest/capabilities';
export const ALERT_MESSAGE_CAP = defineCapability({
  name: 'ALERT_MESSAGE_CAP',
  args: {
    type: args.or(args.literal('info'), args.literal('warning')),
    message: args.string(),
    title: args.string(),
    linkText: args.optional(args.string()),
    href: args.optional(args.string())
  }
});